import * as THREE from 'three'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils.js'

const MINER_MODEL_PATH = 'models/reexminer.glb'

export const MINER_OBJECT_TYPE = 'REEXMINER'

export const MINER_TARGET_SIZE = 12
export const MINER_ALTITUDE = 0
const MINER_HITBOX_RADIUS = 8
export const MINER_PREVIEW_OPACITY = 0.55
export const MINER_SPIN_SPEED = 0.6

let modelPromise: Promise<THREE.Group> | null = null

const loadMinerModel = (): Promise<THREE.Group> => {
  if (modelPromise) return modelPromise

  modelPromise = new Promise((resolve, reject) => {
    new GLTFLoader().load(
      MINER_MODEL_PATH,
      (gltf) => {
        const scene = gltf.scene

        const box = new THREE.Box3().setFromObject(scene)
        const size = box.getSize(new THREE.Vector3())
        const maxSide = Math.max(size.x, size.y, size.z)
        const fit = maxSide > 0 ? MINER_TARGET_SIZE / maxSide : 1
        scene.scale.set(fit, fit, -fit)

        const scaledBox = new THREE.Box3().setFromObject(scene)
        scene.position.y -= scaledBox.min.y

        resolve(scene)
      },
      undefined,
      reject
    )
  })

  return modelPromise
}

const makePreviewMaterials = (model: THREE.Object3D) => {
  model.traverse((child) => {
    const mesh = child as THREE.Mesh
    if (!mesh.isMesh) return
    const cloneMaterial = (material: THREE.Material) => {
      const clone = material.clone()
      clone.transparent = true
      clone.opacity = MINER_PREVIEW_OPACITY
      clone.depthWrite = false
      return clone
    }
    mesh.material = Array.isArray(mesh.material)
      ? mesh.material.map(cloneMaterial)
      : cloneMaterial(mesh.material)
  })
}

export function createMinerObject(isPreview = false): THREE.Group {
  const group = new THREE.Group()
  group.userData.spinSpeed = MINER_SPIN_SPEED

  const hitbox = new THREE.Mesh(
    new THREE.SphereGeometry(MINER_HITBOX_RADIUS, 8, 8),
    new THREE.MeshBasicMaterial({
      transparent: true,
      opacity: 0,
      depthWrite: false,
    })
  )
  hitbox.position.y = MINER_HITBOX_RADIUS * 0.5
  group.add(hitbox)

  loadMinerModel()
    .then((asset) => {
      const model = SkeletonUtils.clone(asset) as THREE.Group
      if (isPreview) {
        makePreviewMaterials(model)
      }
      group.add(model)
    })
    .catch((err) => console.error('MinerObject: ошибка загрузки модели', err))

  return group
}
